module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    style: (_vm.getStyle),
    attrs: {
      "id": "timetableHeader"
    }
  }, [_c('thead', [_c('ruler-header', {
    attrs: {
      "classroom": ""
    }
  }), _vm._v(" "), _vm._l((_vm.filteredclassroomNames), function(classroom) {
    return _c('timeline-header', {
      key: classroom.name,
      attrs: {
        "classroom": classroom.name
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47a6e666"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/TimetableHeader.vue
// module id = 699
// module chunks = 0